export const cost_unity = (totalcost, qtd) => {
  const data = totalcost / qtd
  if (isNaN(data) || data == undefined) return 0
  return data
}

export const sell = (cost_unit, gainP, dapp, fixas, variaveis) => {
  dapp = !dapp ? 0 : dapp
  gainP = !gainP ? 0 : gainP
  dapp = !dapp ? 0 : dapp
  const cost_unit_f = parseFloat(cost_unit)
  const gain_f = parseFloat(gainP)
  const data = cost_unit_f / (1 - fixas / 100 - variaveis / 100 - gain_f / 100 - dapp / 100)
  if (isNaN(data)) return 0
  return data
}

export const gainCalculated = (cost_unit, price_gived, fixas, variaveis) => {
  const percentage = 1 - cost_unit / price_gived - fixas / 100 - variaveis / 100
  return percentage * 100
}

export const rival = (dapp, rival, fixas, variaveis, cost) => {
  dapp = !dapp ? 0 : dapp

  const percentage = 1 - cost / rival - fixas / 100 - variaveis / 100 - dapp / 100
  return percentage * 100
}

export const DAS = (faturamentoAnual) => {
  let aliquota
  let valorADeduzir

  if (faturamentoAnual <= 180000) {
    aliquota = 4.0
    valorADeduzir = 0
  } else if (faturamentoAnual <= 360000) {
    aliquota = 7.3
    valorADeduzir = 5940
  } else if (faturamentoAnual <= 720000) {
    aliquota = 9.5
    valorADeduzir = 13860
  } else if (faturamentoAnual <= 1800000) {
    aliquota = 10.7
    valorADeduzir = 22500
  } else if (faturamentoAnual <= 3600000) {
    aliquota = 14.3
    valorADeduzir = 87300
  } else if (faturamentoAnual <= 4800000) {
    aliquota = 19.0
    valorADeduzir = 378000
  }

  let valorDAS = ((faturamentoAnual * aliquota) / 100 - valorADeduzir) / faturamentoAnual

  return valorDAS * 100
}
